import React, { useState, useEffect, useContext } from "react";
import { GlobalContext } from "../../Context/GlobalState";
import TwoFactor from "./TwoFactor";
import BalanceEnq from "./BalanceEnq";
import CashWithdrawal from "./Cashwithdrawal";
import MiniStatement from "./MiniStatement";
import CashDeposit from "./CashDeposit";
import Reports from "./Report";
import AepsLogo from "../../../assets/images/AEPS-Png.png";
import { Tabs, Tab, Form, Dropdown, Button, Row, Col } from "react-bootstrap";
import { BASE_URL_API, BASE_URL_APISERVICES } from "../../utils/Constants";
import swal from "sweetalert";
import { getLatLong } from "../../utils/utilFuctions";
import ChangeMobile from "./ChangeMobile";
import Select from "react-select";
import { RetailerApi_Endpoint } from "../../utils/RetailerApiEndpoint";
import { adminAuth } from "../../config";

const AepsInstaPay = () => {
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [agentId, setAgentId] = useState("");
  const [kycStatus, setKycStatus] = useState({});
  const [twoFactorStatus, setTwoFactorStatus] = useState({});
  const [activeTab, setActiveTab] = useState(0);

  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  const getKycAndTwoFactorStatus = async () => {
    try {
      setTransactionLoaderState(true);
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        userid: user.ReferId,
        pipe: "INSTAPAY",
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_APISERVICES}${RetailerApi_Endpoint.GET_KYC_TWO_FACTOR_STATUS}`,
        requestOptions
      );

      const data = await res.json();
      if (data.responseCode == "00") {
        setKycStatus(data.data.kycStatus);
        setTwoFactorStatus(data.data.twoFactorStatus);
      } else {
        swal("Failed", data.msg, "error");
      }
      setTransactionLoaderState(false);
    } catch (error) {
      setTransactionLoaderState(false);
      console.log("error", error);
      swal("Failed", "Error From Server", "error");
    }
  };

  useEffect(() => {
    getKycAndTwoFactorStatus();
  }, []);
  return (
    <div className="p-4 bg-light" style={{ fontFamily: "auto" }}>
      <div>
        <div className="card mb-3 m-0 p-0">
          <div className="card-body m-0 p-0 pt-1 pb-1 pl-3 pr-2">
            <div className="row m-0 p-0 pb-4 pt-3 align-items-center justify-content-between">
              <div className="col-auto">
                <h2
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "32px",
                    fontWeight: "700",
                    color: "#4267B2",
                    margin: 0,
                  }}
                >
                  AEPS 2
                </h2>
              </div>
              <div className="col-auto">
                <img
                  src={AepsLogo}
                  alt="AEPS Logo"
                  style={{ height: "78px", width: "auto" }}
                />
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="card m-0 p-0 pt-3">
            <div className="card-body m-0 p-0">
              <div style={{ overflowX: "auto", width: "100%" }}>
                <div
                  defaultActiveKey="profile"
                  className=" tab-header justify-content-between"
                >
                  <div
                    className={`tab-item ${activeTab === 6 ? "active" : ""} ${kycStatus === "Y" ? "disabled-tab" : ""}`}
                    // className={`tab-item`}
                    // onClick={() => handleTabClick(6)}
                    onClick={() => kycStatus !== "Y" && handleTabClick(6)}
                    style={{
                      cursor: kycStatus === "Y" ? "not-allowed" : "pointer",
                      opacity: kycStatus === "Y" ? 0.5 : 1,
                    }}
                  >
                    E Kyc
                  </div>
                  <div
                    className={`tab-item ${activeTab === 7 ? "active" : ""}`}
                    onClick={() => handleTabClick(7)}
                  >
                    Check Mobile
                  </div>
                  <div
                    className={`tab-item ${activeTab === 0 ? "active" : ""} ${twoFactorStatus === "Y" ? "disabled-tab" : ""
                      }`}
                    onClick={() => twoFactorStatus !== "Y" && handleTabClick(0)}
                    style={{
                      cursor:
                        twoFactorStatus === "Y" ? "not-allowed" : "pointer",
                      opacity: twoFactorStatus === "Y" ? 0.5 : 1,
                    }}
                  >
                    Two Factor
                  </div>

                  <div
                    className={`tab-item ${activeTab === 1 ? "active" : ""}`}
                    onClick={() => handleTabClick(1)}
                  >
                    Balance Inquery
                  </div>
                  <div
                    className={`tab-item ${activeTab === 2 ? "active" : ""}`}
                    onClick={() => handleTabClick(2)}
                  >
                    Cash Withrawal
                  </div>

                  <div
                    className={`tab-item ${activeTab === 3 ? "active" : ""}`}
                    onClick={() => handleTabClick(3)}
                  >
                    Mini Statement
                  </div>
                  <div
                    className={`tab-item ${activeTab === 4 ? "active" : ""}`}
                    onClick={() => handleTabClick(4)}
                  >
                    Cash Deposit
                  </div>

                  <div
                    className={`tab-item ${activeTab === 5 ? "active" : ""}`}
                    onClick={() => handleTabClick(5)}
                  >
                    Report
                  </div>
                </div>
                <div className="tab-content">
                  {twoFactorStatus !== "Y" && activeTab === 0 && (
                    <div>
                      <TwoFactor agentId={agentId} />
                    </div>
                  )}
                  {activeTab === 1 && (
                    <div>
                      <BalanceEnq agentId={agentId} />
                    </div>
                  )}
                  {activeTab === 2 && (
                    <div>
                      <CashWithdrawal agentId={agentId} />
                    </div>
                  )}
                  {activeTab === 3 && (
                    <div>
                      {" "}
                      <MiniStatement agentId={agentId} />{" "}
                    </div>
                  )}
                  {activeTab === 4 && (
                    <div>
                      {" "}
                      <CashDeposit agentId={agentId} />
                    </div>
                  )}
                  {activeTab === 5 && (
                    <div>
                      {" "}
                      <Reports agentId={agentId} />
                    </div>
                  )}
                  {activeTab === 7 && (
                    <div>
                      {" "}
                      <ChangeMobile agentId={agentId} />
                    </div>
                  )}
                  {kycStatus !== "Y" && activeTab === 6 && (
                    // {activeTab === 6 && (
                    <div>
                      <EKyc agentId={agentId} />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

var convert = require("xml-js");

const EKyc = () => {
  const { username1, password1 } = adminAuth;
  const [bankList, setBankList] = useState([]);
  const [encryptedData, setEncryptedData] = useState("");
  const storedDevice = localStorage.getItem("device")
    ? localStorage.getItem("device")
    : -1;

  const deviceOptions = [
    { value: 0, label: "Mantra MFS 100" },
    { value: 1, label: "Morpho MSO 1300" },
    { value: 2, label: "Startek FM220U" },
  ];

  const mantraPorts = [
    "11100",
    "11101",
    "11102",
    "11103",
    "11104",
    "11105",
    "11106",
  ];
  const discoverDevice = () => {
    let found = false;

    const protocalls = ["http", "https"];
    // https
    protocalls.forEach((p) => {
      for (let i = 0; i < mantraPorts.length && !found; i++) {
        const currentPort = mantraPorts[i];
        try {
          discoverDeviceReq(currentPort, p, () => {
            found = true;
            setDevicePort(currentPort);
            getDeviceInfo(currentPort, p);
            setProtocall(p);
          });
        } catch (error) { }
      }
    });
  };

  function getDeviceInfo(port, proto) {
    let url;
    if (device == 0) {
      url = `${proto}://localhost:${port}/rd/info`;
    }
    if (device == 1) {
      url = `${proto}://localhost:${port}/getDeviceInfo`;
    }
    if (device == 2) {
      url = `${proto}://localhost:${port}/rd/info`;
    }

    console.log(url);

    var xhr;
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
      // If Internet Explorer, return version number
      //IE browser
      xhr = new window.ActiveXObject("Microsoft.XMLHTTP");
    } else {
      //other browser
      xhr = new XMLHttpRequest();
    }

    //
    xhr.open("DEVICEINFO", url, true);

    xhr.onreadystatechange = function () {
      // if(xhr.readyState == 1 && count == 0){
      // fakeCall();
      //}
      if (xhr.readyState == 4) {
        var status = xhr.status;

        if (status == 200) {
          var result1 = convert.xml2json(xhr.responseText, {
            compact: true,
            spaces: 4,
          });
          const data1 = JSON.parse(result1);
          if (
            data1.DeviceInfo?.additional_info?.Param[0]._attributes.value == ""
          ) {
            // alert('device is not ready');
            setSnackbarState({
              ...snackbarState,
              success: "",
              error: "device is not ready",
            });
          } else {
            setSnackbarState({
              ...snackbarState,
              success: "device is ready to use",
              error: "",
            });
            // alert('device is ready to use');
          }
          setDeviceInfo(data1);
        } else {
          console.log(xhr.response);
        }
      }
    };

    xhr.send();
  }

  function discoverDeviceReq(port, proto, callback) {
    let url;
    if (device == 0) {
      url = `${proto}://localhost:${port}/rd/info`;
    }
    if (device == 1) {
      url = `${proto}://localhost:${port}/getDeviceInfo`;
    }

    if (device == 2) {
      url = `${proto}://localhost:${port}/rd/info`;
    }

    var xhr;
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
      // If Internet Explorer, return version number
      //IE browser
      xhr = new window.ActiveXObject("Microsoft.XMLHTTP");
    } else {
      //other browser
      xhr = new XMLHttpRequest();
    }

    //
    xhr.open("DEVICEINFO", url, true);

    xhr.onreadystatechange = function () {
      // if(xhr.readyState == 1 && count == 0){
      // fakeCall();
      //}
      if (xhr.readyState == 4) {
        var status = xhr.status;

        if (status == 200) {
          var result1 = convert.xml2json(xhr.responseText, {
            compact: true,
            spaces: 4,
          });
          const data1 = JSON.parse(result1);
          console.log(data1);
          if (
            data1.DeviceInfo?.additional_info?.Param[0]._attributes.value == ""
          ) {
            // alert('device is not ready');
            // setSnackbarState({ ...snackbarState, success: "", error: "device is not ready" });
          } else {
            // setSnackbarState({ ...snackbarState, success: "device is ready to use", error: "" })
            // alert('device is ready to use');
            callback();
          }
          // setDeviceInfo(data1);
        } else {
        }
      }
    };

    xhr.send();
  }

  function mantraCapture(isKyc, callback) {
    var url = `${protocall}://localhost:${devicePort}/rd/capture`;
    let PIDOPTS = "";
    if (isKyc) {
      PIDOPTS =
        '<?xml version="1.0"?> <PidOptions ver="1.0"> <Opts fCount="1" fType="2" iCount="0" pCount="0" format="0" pidVer="2.0" timeout="10000" posh="UNKNOWN" env="P" wadh="E0jzJ/P8UopUHAieZn8CKqS4WPMi5ZSYXgfnlfkWjrc=" /> <CustOpts><Param name="mantrakey" value="undefined" /></CustOpts> </PidOptions>';
    } else {
      PIDOPTS =
        '<?xml version="1.0"?> <PidOptions ver="1.0"> <Opts fCount="1" fType="2" iCount="0" pCount="0" format="0" pidVer="2.0" timeout="10000" posh="UNKNOWN" env="P" wadh="" /> <CustOpts><Param name="mantrakey" value="undefined" /></CustOpts> </PidOptions>';
    }

    /*
         format=\"0\" --> XML
         format=\"1\" --> Protobuf
         */
    var xhr;
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
      // If Internet Explorer, return version number
      //IE browser
      xhr = new window.ActiveXObject("Microsoft.XMLHTTP");
    } else {
      //other browser
      xhr = new XMLHttpRequest();
    }

    xhr.open("CAPTURE", url, true);
    xhr.setRequestHeader("Content-Type", "text/xml");
    xhr.setRequestHeader("Accept", "text/xml");

    xhr.onreadystatechange = function () {
      //if(xhr.readyState == 1 && count == 0){
      // fakeCall();
      //}
      if (xhr.readyState == 4) {
        var status = xhr.status;
        //parser = new DOMParser();
        if (status == 200) {
          var test1 = xhr.responseText;
          var test2 = test1.search("errCode");
          var test6 = getPosition(test1, '"', 2);
          var test4 = test2 + 9;
          var test5 = test1.slice(test4, test6);
          // conversion
          var result1 = convert.xml2json(test1, { compact: true, spaces: 4 });
          setPidData(JSON.parse(result1));
          if (test5 > 0) {
            setSnackbarState({
              ...snackbarState,
              error: xhr.responseText,
              success: "",
            });
            alert(xhr.responseText);
            //document.getElementById('text').value = xhr.responseText;
          } else {
            setSnackbarState({
              ...snackbarState,
              error: "",
              success: "Biometric captured successfully",
            });
            // alert("Captured Successfully");
            var result1 = convert.xml2json(test1, { compact: true, spaces: 4 });
            setPidData(JSON.parse(result1));
            if (callback) callback(JSON.parse(result1));
            //document.getElementById('text').value = "Captured Successfully";
          }
        } else {
        }
      }
    };

    xhr.send(PIDOPTS);
  }

  function getPosition(string, subString, index) {
    return string.split(subString, index).join(subString).length;
  }

  function startekCapture(isKyc, callback) {
    var url = `${protocall}://localhost:${devicePort}/rd/capture`;
    let PIDOPTS = "";
    if (isKyc) {
      PIDOPTS =
        '<PidOptions ver="1.0">' +
        '<Opts fCount="1" fType="2" iCount="" iType="" pCount="" pType="" format="0" pidVer="2.0" timeout="10000" otp="" wadh="E0jzJ/P8UopUHAieZn8CKqS4WPMi5ZSYXgfnlfkWjrc=" posh=""/>' +
        "</PidOptions>";
    } else {
      PIDOPTS =
        '<PidOptions ver="1.0">' +
        '<Opts fCount="1" fType="2" iCount="" iType="" pCount="" pType="" format="0" pidVer="2.0" timeout="10000" otp="" wadh="" posh=""/>' +
        "</PidOptions>";
    }

    /*
         format=\"0\" --> XML
         format=\"1\" --> Protobuf
         */
    var xhr;
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
      // If Internet Explorer, return version number
      //IE browser
      xhr = new window.ActiveXObject("Microsoft.XMLHTTP");
    } else {
      //other browser
      xhr = new XMLHttpRequest();
    }

    xhr.open("CAPTURE", url, true);
    xhr.setRequestHeader("Content-Type", "text/xml");
    xhr.setRequestHeader("Accept", "text/xml");

    xhr.onreadystatechange = function () {
      //if(xhr.readyState == 1 && count == 0){
      // fakeCall();
      //}
      if (xhr.readyState == 4) {
        var status = xhr.status;
        //parser = new DOMParser();
        if (status == 200) {
          var test1 = xhr.responseText;
          var test2 = test1.search("errCode");
          var test6 = getPosition(test1, '"', 2);
          var test4 = test2 + 9;
          var test5 = test1.slice(test4, test6);
          // conversion

          if (test5 > 0) {
            // alert(xhr.responseText);
            setSnackbarState({
              ...snackbarState,
              error: xhr.responseText,
              success: "",
            });
            //document.getElementById('text').value = xhr.responseText;
          } else {
            setSnackbarState({
              ...snackbarState,
              error: "",
              success: "Biometric captured successfully",
            });
            // alert("Captured Successfully");
            var result1 = convert.xml2json(test1, { compact: true, spaces: 4 });
            setPidData(JSON.parse(result1));
            if (callback) callback(JSON.parse(result1));
            //document.getElementById('text').value = "Captured Successfully";
          }
        } else {
        }
      }
    };

    xhr.send(PIDOPTS);
  }

  function morphoCapture(isKyc, callback) {
    var url = `${protocall}://localhost:${devicePort}/capture`;
    let PIDOPTS = "";
    if (isKyc) {
      PIDOPTS =
        '<PidOptions ver="1.0">' +
        '<Opts fCount="1" fType="2" iCount="" iType="" pCount="" pType="" format="0" pidVer="2.0" timeout="10000" otp="" wadh="E0jzJ/P8UopUHAieZn8CKqS4WPMi5ZSYXgfnlfkWjrc=" posh=""/>' +
        "</PidOptions>";
    } else {
      PIDOPTS =
        '<PidOptions ver="1.0">' +
        '<Opts fCount="1" fType="2" iCount="" iType="" pCount="" pType="" format="0" pidVer="2.0" timeout="10000" otp="" wadh="" posh=""/>' +
        "</PidOptions>";
    }

    /*
         format=\"0\" --> XML
         format=\"1\" --> Protobuf
         */
    var xhr;
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
      // If Internet Explorer, return version number
      //IE browser
      xhr = new window.ActiveXObject("Microsoft.XMLHTTP");
    } else {
      //other browser
      xhr = new XMLHttpRequest();
    }

    xhr.open("CAPTURE", url, true);
    xhr.setRequestHeader("Content-Type", "text/xml");
    xhr.setRequestHeader("Accept", "text/xml");

    xhr.onreadystatechange = function () {
      //if(xhr.readyState == 1 && count == 0){
      // fakeCall();
      //}
      if (xhr.readyState == 4) {
        var status = xhr.status;
        //parser = new DOMParser();
        if (status == 200) {
          var test1 = xhr.responseText;
          var test2 = test1.search("errCode");
          var test6 = getPosition(test1, '"', 2);
          var test4 = test2 + 9;
          var test5 = test1.slice(test4, test6);
          // conversion

          if (test5 > 0) {
            // alert(xhr.responseText);
            setSnackbarState({
              ...snackbarState,
              error: xhr.responseText,
              success: "",
            });
            //document.getElementById('text').value = xhr.responseText;
          } else {
            setSnackbarState({
              ...snackbarState,
              error: "",
              success: "Biometric captured successfully",
            });
            // alert("Captured Successfully");
            var result1 = convert.xml2json(test1, { compact: true, spaces: 4 });
            setPidData(JSON.parse(result1));
            if (callback) callback(JSON.parse(result1));
            //document.getElementById('text').value = "Captured Successfully";
          }
        } else {
        }
      }
    };

    xhr.send(PIDOPTS);
  }

  const capture = (isKyc, callback) => {
    if (
      !deviceInfo ||
      !deviceInfo.DeviceInfo ||
      !deviceInfo.DeviceInfo.additional_info ||
      deviceInfo.DeviceInfo.additional_info.Param.length == 0
    ) {
      // alert("Please choose device or check device is ready or not");
      setSnackbarState({
        ...snackbarState,
        error: "Please choose device or check device is ready or not",
        success: "",
      });
    } else if (
      device == 0 &&
      deviceInfo.DeviceInfo.additional_info.Param[0]._attributes.value != ""
    ) {
      setSnackbarState({ ...snackbarState, error: "", success: "" });
      mantraCapture(isKyc, callback);
    } else if (
      device == 1 &&
      deviceInfo.DeviceInfo.additional_info.Param[0]._attributes.value != ""
    ) {
      setSnackbarState({ ...snackbarState, error: "", success: "" });
      morphoCapture(isKyc, callback);
    } else if (
      device == 2 &&
      deviceInfo.DeviceInfo.additional_info.Param[0]._attributes.value != ""
    ) {
      setSnackbarState({ ...snackbarState, error: "", success: "" });
      startekCapture(isKyc, callback);
    } else {
      // alert("Please choose device or check device is ready or not");
      setSnackbarState({
        ...snackbarState,
        error: "Please choose device or check device is ready or not",
        success: "",
      });
    }
  };

  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const initialState = {
    mobile: "",
    otp: "",
    aadhar: "",
    pan: "",
  };
  const initialState2 = {
    pan: "",
    bank: "",
    aadhar: "",
    Device: "",
  };
  const [state, setState] = useState(initialState);
  const [agentId, setAgentId] = useState("");
  const [deviceInfo, setDeviceInfo] = useState(null);
  const [snackbarState, setSnackbarState] = useState({
    error: "",
    success: "",
  });
  const [device, setDevice] = useState(0);
  const [pidData, setPidData] = useState(null);

  // did mount
  useEffect(() => {
    // if (agentId && agentId.length > 4) searchUser();
  }, [agentId]);

  const [activeTab, setActiveTab] = useState(0);
  const [showOtpSection, setShowOtpSection] = useState(false);
  const [hash, setHash] = useState("");
  const [otpReferenceID, setOtpReferenceID] = useState("");
  const [protocall, setProtocall] = useState("http");
  const [devicePort, setDevicePort] = useState("11100");
  const [apiMessage, setApiMessage] = useState("");
  const [apiStatus, setApiStatus] = useState("");
  const [showBiometric, setShowBiometric] = useState(false);

  const [externalRef, setExternalRef] = useState("");

  function getPosition(string, subString, index) {
    return string.split(subString, index).join(subString).length;
  }

  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  const loginWithOtp = async (callback) => {
    try {
      setTransactionLoaderState(true);
      const location = await getLatLong();
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        userid: user.ReferId,
        mobile: state.mobile,
        latitude: location[0],
        longitude: location[1],
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API}${RetailerApi_Endpoint.MERCHANT_ONBOARDING_STATUS}`,
        requestOptions
      );
      const data = await res.json();

      if (data.responseCode === "00") {
        setApiMessage(
          `${data.responseMessage}. Now you can do eKYC by capturing the fingerprint.`
        );
        setApiStatus("success");
        setShowBiometric(true);
        setExternalRef(data.referenceKey);
      } else {
        setApiMessage(data.responseMessage);
        setApiStatus("error");
      }

      setTransactionLoaderState(false);
    } catch (error) {
      setTransactionLoaderState(false);
      console.log("error", error);

      swal("error", "Please check your connection and try again!", "error");
      setShowOtpSection(false);
    }
  };

  const validateLoginOtp = async (callback) => {
    try {
      setTransactionLoaderState(true);
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        userid: user.ReferId,
        hash: hash,
        referenceId: otpReferenceID,
        otp: state.otp,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_APISERVICES}${RetailerApi_Endpoint.MERCHANT_ONBOARDING_VALIDATE_OTP}`,
        requestOptions
      );
      const data = await res.json();

      if (data.responseCode == "00") {
        swal("Success", data.responseMessage, "success");
        setTransactionLoaderState(false);
      } else {
        swal("Failed", data.responseMessage, "error");
        setTransactionLoaderState(false);
      }
    } catch (error) {
      console.log("error", error);
      swal("Error", "Network error. Please try again!", "error");
      setTransactionLoaderState(false);
    }
  };

  const getUserViewProfileDetails = async (callback) => {
    try {
      setTransactionLoaderState(true);
    
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Basic " + Buffer.from(username1 + ":" + password1).toString("base64")
      );
    

      var raw = JSON.stringify({
        userid: user.ReferId,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_APISERVICES}${RetailerApi_Endpoint.GET_USER_VIEW_PROFILE_DETAILS}`,
        requestOptions
      );
      const data = await res.json();

      if (data.responseCode == "00") {
        // swal("Success", data.responseMessage, "success");

        const userData = data.data;

        setState((prevState) => ({
          ...prevState,
          aadhar: userData.aadhar_card_no || "",
          pan: userData.pan_card_no || "",
          mobile: userData.usr_mobile || "",
        }));

        setShowOtpSection(true);
      } else {
        swal("Failed", data.responseMessage, "error");
      }

      setTransactionLoaderState(false);
    } catch (error) {
      setTransactionLoaderState(false);
      console.log("error", error);
      swal(
        "Error",
        "Network error. Please check your connection and try again!",
        "error"
      );
    }
  };

  const aepsTwoFactor = async (pidData) => {
    try {
      setTransactionLoaderState(true);
      const location = await getLatLong();
      // const location = ["23.568561", "78.574579"]; // Dummy location for testing
      const deviceData = getDeviceData();
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        userid: user.ReferId,
        type: "DAILY_LOGIN",
        serviceType: "CashDeposit",
        latitude: location[0],
        longitude: location[1],
        captureType: "FINGER",
        biometricData: {
          encryptedAadhaar: state.aadhar,
          errCode: pidData.PidData.Resp._attributes.errCode,
          errInfo: pidData.PidData.Resp._attributes.errInfo,
          fCount: pidData.PidData.Resp._attributes.fCount,
          fType: pidData.PidData.Resp._attributes.fType,
          iCount: pidData.PidData.Resp._attributes.iCount,
          iType: pidData.PidData.Resp._attributes.iType,
          pCount: pidData.PidData.Resp._attributes.pCount,
          pType: pidData.PidData.Resp._attributes.pType,
          pidDataType: pidData.PidData.Resp._attributes.pType,
          nmPoints: pidData.PidData.Resp._attributes.nmPoints,
          qScore: pidData.PidData.Resp._attributes.qScore.toString().trim(),
          dpId: pidData.PidData.DeviceInfo._attributes.dpId,
          rdsId: pidData.PidData.DeviceInfo._attributes.rdsId,
          rdsVer: pidData.PidData.DeviceInfo._attributes.rdsVer,
          dc: pidData.PidData.DeviceInfo._attributes.dc,
          mi: pidData.PidData.DeviceInfo._attributes.mi,
          mc: pidData.PidData.DeviceInfo._attributes.mc,
          ci: pidData.PidData.Skey._attributes.ci,
          sessionKey: pidData.PidData.Skey._text,
          hmac: pidData.PidData.Hmac._text,
          PidDatatype: pidData.PidData.Data._attributes.type,
          pidData: pidData.PidData.Data._text,
          srno: deviceData.srno,
          sysid: deviceData.sysid,
          ts: deviceData.ts,
        },
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_APISERVICES}${RetailerApi_Endpoint.AEPS_TWO_FACTOR}`,
        requestOptions
      );

      const data = await res.json();
      if (data.responseCode == "00") {
        swal("Successful", data.responseMessage, "success");
        clearForm();
      } else {
        swal("User Registration Failed", data.responseMessage, "error");
      }
      setTransactionLoaderState(false);
    } catch (error) {
      setTransactionLoaderState(false);
      console.log("error", error);
      swal("User Registration Failed", "Error From Server", "error");
    }
  };

  const merchantOnboardingBiometricKyc = async (pidData) => {
    try {
      setTransactionLoaderState(true);
      const location = await getLatLong();
      const deviceData = getDeviceData();
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        userid: user.ReferId,
        mobile: state.mobile,
        latitude: location[0],
        longitude: location[1],
        externalRef: externalRef,
        biometricData: {
          encryptedAadhaar: state.aadhar,
          dc: pidData.PidData.DeviceInfo._attributes.dc,
          ci: pidData.PidData.Skey._attributes.ci,
          hmac: pidData.PidData.Hmac._text,
          dpId: pidData.PidData.DeviceInfo._attributes.dpId,
          mc: pidData.PidData.DeviceInfo._attributes.mc,
          PidDatatype: pidData.PidData.Data._attributes.type,
          rdsId: pidData.PidData.DeviceInfo._attributes.rdsId,
          sessionKey: pidData.PidData.Skey._text,
          mi: pidData.PidData.DeviceInfo._attributes.mi,
          errCode: pidData.PidData.Resp._attributes.errCode,
          errInfo: pidData.PidData.Resp._attributes.errInfo,
          fCount: pidData.PidData.Resp._attributes.fCount,
          fType: pidData.PidData.Resp._attributes.fType,
          iCount: pidData.PidData.Resp._attributes.iCount,
          fType: pidData.PidData.Resp._attributes.fType,
          pCount: pidData.PidData.Resp._attributes.pCount,
          pType: pidData.PidData.Resp._attributes.pType,
          srno: deviceData.srno,
          sysid: deviceData.sysid,
          ts: deviceData.ts,
          pidData: pidData.PidData.Data._text,
          qScore: pidData.PidData.Resp._attributes.qScore.toString().trim(),
          nmPoints: pidData.PidData.Resp._attributes.nmPoints,
          rdsVer: pidData.PidData.DeviceInfo._attributes.rdsVer,
        },
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_APISERVICES}${RetailerApi_Endpoint.MERCHANT_ONBOARDING_BIOMETRICKYC}`,
        requestOptions
      );

      const data = await res.json();
      if (data.responseCode == "00") {
        swal("Successful", data.responseMessage, "success");
        clearForm();
      } else {
        swal("User Registration Failed", data.responseMessage, "error");
      }
      setTransactionLoaderState(false);
    } catch (error) {
      setTransactionLoaderState(false);
      console.log("error", error);
      swal("User Registration Failed", "Error From Server", "error");
    }
  };

  const getDeviceData = () => {
    // srno : deviceInfo.DeviceInfo.additional_info.Param[0]._attributes.value,
    const deviceData = {};
    deviceInfo.DeviceInfo.additional_info.Param.forEach((item) => {
      if (item._attributes.name == "srno") {
        deviceData.srno = item._attributes.value;
      }
      if (item._attributes.name == "sysid") {
        deviceData.sysid = item._attributes.value;
      }
      if (item._attributes.name == "ts") {
        deviceData.ts = item._attributes.value;
      }
    });

    return deviceData;
  };
  const clearForm = () => {
    setState(initialState2);
  };

  useEffect(() => {
    getUserViewProfileDetails();
  }, []);
  useEffect(() => {
    // setSnackbarState({ error: "", success: "" });
    // console.log(deviceInfo);
    if (state.Device !== -1) discoverDevice();
  }, [state.Device]);

  useEffect(() => {
    if (state.Device !== -1) discoverDevice();
  }, [state.Device]);

  // setTimeout(() => {
  // setApiMessage("");
  // }, 5000);

  return (
    <div className="p-4 bg-light" style={{ fontFamily: "auto" }}>
      <div>
        <div style={{ padding: "1rem" }} className="bg-light ">
          <div
            style={{ borderRadius: "10px" }}
            className="card p-0 m-0 mx-2 mt-4 "
          >
            <div className="card-body m-0 p-3">
              <div>
                <div
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "32px",
                    fontWeight: "600",
                    lineHeight: "48px",
                    letterSpacing: "0em",
                    textAlign: "left",
                    padding: "0px",
                    background: "#FFFFFF",
                    color: "#4267B2",
                    fontWeight: "bolder",
                    fontfamily: "Poppins !impotent",
                    fontSize: "28px",
                  }}
                >
                  E Kyc
                </div>
                <div className="mt-2">
                  <div className="col-10 m-0 p-0">
                    <div className="row m-0 p-0">
                      <div className="col-6 p-0 pr-2 ">
                        <Form.Group>
                          <Form.Label>
                            <span style={{ color: "red" }}>*</span>
                            <span style={{ color: "black" }}> User ID</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            className="form-control rounded-100"
                            aria-label="Notes"
                            aria-describedby="basic-addon1"
                            placeholder="Enter User ID"
                            value={user.ReferId}
                            readOnly
                          />
                        </Form.Group>
                      </div>

                      <div className="col-6 p-0 pr-2 ">
                        <Form.Group>
                          <Form.Label>
                            <span style={{ color: "red" }}>*</span>
                            <span style={{ color: "black" }}>
                              {" "}
                              Mobile No linked to your Aadhaar
                            </span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            className="form-control rounded-100"
                            aria-label="Notes"
                            aria-describedby="basic-addon1"
                            placeholder="Enter Mobile No"
                            value={state.mobile}
                            maxLength={10}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (/^\d{0,10}$/.test(value)) {
                                setState({ ...state, mobile: value });
                              }
                            }}
                          />
                          {state.mobile && state.mobile.length !== 10 && (
                            <div
                              style={{
                                color: "red",
                                fontSize: "0.85rem",
                                marginTop: "4px",
                              }}
                            >
                              Mobile number must be 10 digits
                            </div>
                          )}
                        </Form.Group>
                      </div>
                    </div>
                  </div>
                  <div className="col-10 m-0 p-0">
                    <div className="row m-0 p-0">
                      <div className="col-6 p-0 pr-2 ">
                        <Form.Group>
                          <Form.Label>
                            <span style={{ color: "red" }}>*</span>
                            <span style={{ color: "black" }}>Aadhar No</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            className="form-control rounded-100"
                            placeholder="Enter Aadhar No"
                            value={state.aadhar}
                            readOnly
                          />
                        </Form.Group>
                      </div>

                      <div className="col-6 p-0 pr-2 ">
                        <Form.Group>
                          <Form.Label>
                            <span style={{ color: "red" }}>*</span>
                            <span style={{ color: "black" }}>Pan No</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            className="form-control rounded-100"
                            placeholder="Enter Pan No"
                            value={state.pan}
                            readOnly
                          />
                        </Form.Group>
                      </div>
                    </div>
                  </div>
                  {apiMessage && (
                    <div
                      style={{
                        marginBottom: "12px",
                        padding: "10px 14px",
                        borderRadius: "6px",
                        fontSize: "0.9rem",
                        fontWeight: "500",
                        border:
                          apiStatus === "success"
                            ? "1px solid #c3e6cb"
                            : "1px solid #f5c6cb",
                        backgroundColor:
                          apiStatus === "success" ? "#d4edda" : "#f8d7da",
                        color: apiStatus === "success" ? "#155724" : "#721c24",
                      }}
                    >
                      {apiMessage}
                    </div>
                  )}
                  {showBiometric && (
                    <div className="col-10 mt-1 p-0">
                      <div className="row m-0 p-0">
                        <div className="col-6 p-0 pr-2 ">
                          <Form.Group className="rounded-100">
                            <Form.Label>
                              <span style={{ color: "red" }}>*</span>
                              <span style={{ color: "black" }}>
                                Choose Biometric Device
                              </span>
                            </Form.Label>
                            <Select
                              options={deviceOptions}
                              value={state.Device}
                              onChange={(e) => {
                                setState({ ...state, Device: e });
                              }}
                            />
                          </Form.Group>
                        </div>
                        <div className="col-6 p-0 pr-2 ">
                          <Form.Label></Form.Label>
                          <button
                            type="button"
                            style={{
                              background: "#277BC0",
                              color: "white",
                              width: "60%",
                            }}
                            className="btn text-primary bg-white border-primary btn-block ml-2"
                            onClick={() => {
                              capture(false, merchantOnboardingBiometricKyc);
                            }}
                          >
                            Capture Fingerprint
                          </button>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="col-10 m-0 p-0">
                    <div className="row m-0 p-0">
                      <div className="col-6 p-0 pr-2 ">
                        <Button
                          className="rounded-50 btn btn-primary btn-lg btn-block"
                          onClick={loginWithOtp}
                        >
                          Submit
                        </Button>
                      </div>

                      <div className="col-6 p-0 pr-2 "></div>
                    </div>
                  </div>
                </div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AepsInstaPay;
